import React from 'react';

import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';

import './SkuReportsSummaryTile.scss';

const { block, element } = bem('sku-reports-summary-tile');

const SummaryTile = ({ label, value, trend, alert = false }) => (
  <div className={block()}>
    <span className={element('label')}>{label}</span>
    <span className={element('value', { alert })}>{value}</span>
    {trend}
  </div>
);

SummaryTile.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  trend: PropTypes.node,
  alert: PropTypes.bool,
};

export const SummaryTileEntries = ({ entries, renderSubtitle }) =>
  entries.map(entry => (
    <span className={element('entry')} key={`${entry.name}::${entry.earnings?.currencyCode || ''}`}>
      <span>{entry.name}</span>
      <span className={element('entry-subtitle')}>{renderSubtitle(entry)}</span>
    </span>
  ));

SummaryTileEntries.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      earnings: PropTypes.shape({ amount: PropTypes.number, currencyCode: PropTypes.string }),
    })
  ).isRequired,
  renderSubtitle: PropTypes.func.isRequired,
};

export const SummaryTileValueLine = ({ children }) => <span className={element('value-line')}>{children}</span>;

SummaryTileValueLine.propTypes = { children: PropTypes.node.isRequired };

export const SummaryTileTrend = ({ children }) => <span className={element('trend')}>{children}</span>;

SummaryTileTrend.propTypes = { children: PropTypes.node.isRequired };

export const SummaryTileTrendDelta = ({ isGood, children }) => (
  <span className={element('trend-delta', { good: isGood === true, bad: isGood === false })}>{children}</span>
);

SummaryTileTrendDelta.propTypes = { isGood: PropTypes.bool, children: PropTypes.node.isRequired };

export default SummaryTile;
